/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable max-len */
/* eslint-disable react/jsx-indent */
/* eslint-disable indent */
import './style.scss';

import { useMemo, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useMutation, useQuery } from 'react-query';
import { Link } from 'react-router-dom';

import { deleteById, getAll as getAllProjectProposals } from 'apis/projectProposals.api';

import { COUNCIL_STATUS, PROJECT_PROPOSAL_STATUSES } from 'constant';
import Confirm from 'features/ProjectProposal/components/Confirm';
import { Button } from 'primereact/button';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { Tag } from 'primereact/tag';

import ViewHistory from 'features/ProjectProposal/components/ViewHistory';
import { isAuthorized, mapError } from 'utils/func';
import ViewRequests from 'features/ProjectProposal/components/ViewRequests';
import { Menu } from 'primereact/menu';
import { Badge } from 'primereact/badge';
// import RequestUpdateType from 'features/ProjectProposal/components/RequestUpdateType';

function ProjectProposalViewList() {
  // #region Data
  const { t } = useTranslation();
  const { data, isLoading, isError, error, refetch } = useQuery(
    'projectProposals',
    getAllProjectProposals
  );
  const projectProposals = useMemo(() => data?.data ?? [], [data?.data]);

  const [viewHistoryVisible, setViewHistoryVisible] = useState(false);
  const [projectHistory, setProjectHistory] = useState([]);
  // const [projectProposal, setProjectProposal] = useState(null);
  // const [isVisibleUpdate, setIsVisibleUpdate] = useState(false);

  const statuses = t('projectProposal.viewList.statuses', { returnObjects: true });
  const user = JSON.parse(localStorage.getItem('user'));
  const dialogConfirmDeleteRef = useRef();
  const dialogViewRequestsRef = useRef();

  const { mutate: mutateDelete } = useMutation(deleteById);
  // #endregion

  // #region Render
  const formatActions = (value) => {
    const menuRef = useRef(null);

    const items = [];

    // Check if there's a result option available
    const hasResult =
      (value?.owner?.id === user?.id || isAuthorized(user?.id, value?.projectProposalContacts)) &&
      value?.status?.name !== PROJECT_PROPOSAL_STATUSES.NEW &&
      value?.program &&
      value?.projectProposalReviseLogs?.length > 0;

    // View
    items.push({
      template: () => (
        <Link
          to={`/project-proposal/${value.id}?template=${value?.program?.template}&programId=${value?.program?.id}`}
          className="p-menuitem-link"
        >
          <span className="p-menuitem-text">{t('projectProposal.viewList.view')}</span>
        </Link>
      ),
    });

    // Edit
    if (
      (value?.owner?.id === user?.id || isAuthorized(user?.id, value?.projectProposalContacts)) &&
      value?.status?.name === PROJECT_PROPOSAL_STATUSES.NEW
    ) {
      items.push({
        template: () => (
          <Link
            to={`/project-proposal/edit/${value.id}?template=${value?.program?.template}&programId=${value?.program?.id}`}
            className="p-menuitem-link"
          >
            <span className="p-menuitem-text">{t('projectProposal.viewList.edit')}</span>
          </Link>
        ),
      });
    }

    // Result
    if (
      (value?.owner?.id === user?.id || isAuthorized(user?.id, value?.projectProposalContacts)) &&
      value?.status?.name !== PROJECT_PROPOSAL_STATUSES.NEW &&
      value?.program
    ) {
      items.push({
        template: () => (
          <Link to={`/project-proposal/request/${value.reference}`} className="p-menuitem-link">
            <div style={{ position: 'relative', display: 'flex', alignItems: 'center' }}>
              <span className="p-menuitem-text">{t('projectProposal.result')}</span>
              {value?.projectProposalReviseLogs?.length > 0 && (
                <Badge
                  severity="danger"
                  style={{
                    marginLeft: '8px',
                    marginTop: '-12px',
                    minWidth: '0.5rem',
                    height: '0.5rem',
                    fontSize: '0.5rem',
                    padding: '0',
                  }}
                />
              )}
            </div>
          </Link>
        ),
      });
    }

    // Delete
    if (value?.owner?.id === user?.id && value?.status?.name === PROJECT_PROPOSAL_STATUSES.NEW) {
      items.push({
        label: t('projectProposal.viewList.delete'),
        command: () => {
          dialogConfirmDeleteRef.current.open({
            mode: 'delete',
            mutate: mutateDelete,
            value,
          });
        },
      });
    }

    // View history
    items.push({
      label: t('projectProposal.viewList.viewHistory'),
      command: () => {
        setProjectHistory(value?.projectLogs ?? []);
        setViewHistoryVisible(true);
      },
    });

    return (
      <div className="flex justify-content-center">
        <Menu model={items} popup ref={menuRef} style={{ minWidth: '250px' }} />
        <div style={{ position: 'relative', display: 'inline-block' }}>
          <Button
            icon="pi pi-ellipsis-v"
            className="p-button-rounded p-button-text"
            onClick={(event) => menuRef.current.toggle(event)}
          />
          {hasResult && (
            <Badge
              severity="danger"
              style={{
                position: 'absolute',
                top: '-2px',
                right: '-2px',
                minWidth: '0.5rem',
                height: '0.5rem',
                fontSize: '0.5rem',
                padding: '0',
              }}
            />
          )}
        </div>
      </div>
    );
  };

  const formatTotalExpenditure = (value) => value.totalExpenditure?.toLocaleString('vi', '0,0');

  const formatStatus = (value) => {
    const statusColorMapping = {
      revise: 'warning',
      new: 'info',
      submit: 'success',
      approved: 'success',
    };

    return (
      <Tag
        style={{ width: '4rem' }}
        severity={statusColorMapping[value.status.name]}
        value={statuses[value.status.name]}
        rounded
      />
    );
  };

  const formatCouncil = (value) => {
    const councilStatusSeverityMap = {
      notReviewed: 'warning',
      notQualified: 'danger',
      qualified: 'success',
    };
    return (
      <div className="flex flex-column">
        {value?.prequalificationCouncilStatus && (
          <>
            <span className="my-1">- {t('council.prequalification')}</span>
            <div className="flex justify-content-center">
              <Tag
                style={{
                  maxWidth: '8rem',
                  minWidth: '4rem',
                  textAlign: 'center',
                }}
                severity={
                  councilStatusSeverityMap[
                    value.prequalificationCouncilStatus ?? COUNCIL_STATUS.NOT_REVIEWED
                  ]
                }
                value={t(
                  `council.viewList.${
                    value.prequalificationCouncilStatus ?? COUNCIL_STATUS.NOT_REVIEWED
                  }`
                )}
                rounded
              />
            </div>
          </>
        )}
        {value?.specializationCouncilStatus && (
          <>
            <span className="my-1">- {t('council.specialization')}</span>
            <div className="flex justify-content-center">
              <Tag
                style={{
                  maxWidth: '8rem',
                  minWidth: '4rem',
                  textAlign: 'center',
                }}
                severity={
                  councilStatusSeverityMap[
                    value.specializationCouncilStatus ?? COUNCIL_STATUS.NOT_REVIEWED
                  ]
                }
                value={t(
                  `council.viewList.${
                    value.specializationCouncilStatus ?? COUNCIL_STATUS.NOT_REVIEWED
                  }`
                )}
                rounded
              />
            </div>
          </>
        )}
        {value?.financeCouncilStatus && (
          <>
            <span className="my-1">- {t('council.finance')}</span>
            <div className="flex justify-content-center">
              <Tag
                style={{
                  maxWidth: '8rem',
                  minWidth: '4rem',
                  textAlign: 'center',
                }}
                severity={
                  councilStatusSeverityMap[
                    value.financeCouncilStatus ?? COUNCIL_STATUS.NOT_REVIEWED
                  ]
                }
                value={t(
                  `council.viewList.${value.financeCouncilStatus ?? COUNCIL_STATUS.NOT_REVIEWED}`
                )}
                rounded
              />
            </div>
          </>
        )}
      </div>
    );
  };
  // #endregion Render

  return (
    <div className="grid">
      <div className="col-12">
        <div className="card">
          {isError && <h3 className="text-red-600">{mapError(t, error)}</h3>}
          {/* <div className="flex justify-content-between align-items-end mb-4 pb-2">
            <h5 className="p-0 m-0">{t('projectProposal.viewList.title')}</h5>
            <Link to="/project-proposal/create">
              <Button
                className="bg-cyan-600 border-cyan-600"
                label={t('projectProposal.viewList.add')}
                icon="pi pi-plus"
              />
            </Link>
          </div> */}
          <div className="flex justify-content-between align-items-end mb-4 pb-2">
            <h5 className="p-0 m-0">{t('projectProposal.viewList.title')}</h5>
          </div>

          <DataTable
            value={projectProposals}
            className="p-datatable-gridlines header-table"
            showGridlines
            dataKey="id"
            filterDisplay="menu"
            loading={isLoading}
            scrollable
            emptyMessage={t('projectProposal.viewList.emptyMessage')}
          >
            <Column
              field="vietnameseName"
              header={t('projectProposal.viewList.nameVN')}
              style={{ minWidth: '12rem' }}
            />
            <Column
              header={t('projectProposal.viewList.owner')}
              headerStyle={{ justifyContent: 'center' }}
              style={{ minWidth: '8rem', textAlign: 'center' }}
              field="owner.fullname"
            />
            <Column
              field="implementationMonths"
              header={t('projectProposal.viewList.implementationTime')}
              dataType="numeric"
              style={{ maxWidth: '10rem', textAlign: 'center' }}
            />
            <Column
              field="totalExpenditure"
              header={t('projectProposal.viewList.totalExpenditure')}
              dataType="numeric"
              style={{ minWidth: '10rem', textAlign: 'center' }}
              body={formatTotalExpenditure}
            />
            <Column
              field="status.name"
              header={t('projectProposal.viewList.status')}
              style={{ width: '9rem', textAlign: 'center' }}
              body={formatStatus}
            />
            <Column
              field="program.name"
              header={t('projectProposal.viewList.program')}
              style={{ minWidth: '12rem', width: '16rem', textAlign: 'center' }}
            />
            <Column
              header={t('projectProposal.result')}
              style={{ minWidth: '8rem', textAlign: 'center' }}
              body={formatCouncil}
            />
            <Column
              header={t('projectProposal.action')}
              body={formatActions}
              style={{ minWidth: '6rem', maxWidth: '16rem', textAlign: 'center' }}
              frozen
              alignFrozen="right"
            />
          </DataTable>
        </div>
      </div>

      <Confirm ref={dialogConfirmDeleteRef} refetch={refetch} />
      <ViewRequests ref={dialogViewRequestsRef} refetchProjectProposals={refetch} />

      <ViewHistory
        data={projectHistory}
        visible={viewHistoryVisible}
        setVisible={setViewHistoryVisible}
        title={t('projectProposal.viewHistory.title')}
      />
      {/* <RequestUpdateType
        isVisible={isVisibleUpdate}
        onHide={() => setIsVisibleUpdate(false)}
        projectProposal={projectProposal}
      /> */}
    </div>
  );
}

export default ProjectProposalViewList;
